import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { CitiesService } from 'src/app/shared/services/cities.service';
import { AddCityComponent } from '../add-city/add-city.component';

@Component({
  selector: 'app-cities-header',
  templateUrl: './cities-header.component.html',
  styleUrls: ['./cities-header.component.less']
})
export class CitiesHeaderComponent implements OnInit {
  modalRef: BsModalRef;
  private unsubscribe$ = new Subject<void>();
  @ViewChild('userame') cityname: ElementRef;
  @Output() searchByName = new EventEmitter();
  @Output() resetFilters = new EventEmitter();
  @Input() tableSettings;
  constructor(private modalService: BsModalService, private citiesService: CitiesService) { 

  }

  ngOnInit(): void {
    this.citiesService.resetHeaders
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.cityname.nativeElement.value = '';
      this.citiesService.refreshPage.next();
    })
  }

  addCity() {
    this.modalRef = this.modalService.show(AddCityComponent);
    this.modalRef.setClass(ModalSize.Large);
  }
  SearchByUser(username) {
    this.searchByName.emit(username);
  }

  ResetFilters() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Reset Filter';
    this.modalRef.content.description = 'Do you want to reset all filters';
    this.modalRef.content.buttonsTitle = {
      dismiss: 'Cancel',
      confirm: 'Reset',
      component: ComponentName.Cities
    }
  }

  hideDropdowns() {
    this.tableSettings.forEach(item => {
      item.displaysort = false;
    })
    // _.each(this.tableSettings, function (item) {
    //   item.displaysort = false;
    // })
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  } 
}
